import type { SerializedQuickFilter } from "@/admin/filterUtils.ts";
import { VmsTable } from "@/admin/vm/VmsTable.tsx";
import { createLazyFileRoute } from "@tanstack/react-router";

export const Route = createLazyFileRoute("/admin/_menu/_dual/virtual_machines")({
    component: Component,
});

export interface VmsTableSearch {
    filters?: (SerializedQuickFilter | undefined)[];
}

function Component() {
    return <VmsTable />;
}
